import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { slideBottom, slideInOut } from '@app/pages/workspace/assign/components/action-container/animation';
import { ShopService } from '@services/shops/shop.service';
import { ECOMMERCES } from '@services/shops/shop.model';
import { IShopMetadata } from '@pdqdev/pdq-shared/dist/interfaces';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { OrderStatus } from '@pdqdev/pdq-shared/dist/entities';
@Component({
  selector: 'app-action-container',
  templateUrl: './action-container.component.html',
  styleUrls: ['./action-container.component.scss'],
  animations: [slideInOut, slideBottom],
  standalone: false,
})
export class ActionContainer implements OnInit, OnChanges, OnDestroy {
  @Input() selected: any[];
  @Input() showContainer: boolean;
  @Input() isBottomScrolled: boolean = false;
  @Input() shopCountry: string;
  @Input() isOrdersUpdating: boolean;
  @Output() onDeselectItems = new EventEmitter<void>();
  @Output() onOpenDialog = new EventEmitter<void>();
  disablePickupCheckOnPlatforms = [ECOMMERCES.WOOCOMMERCE];

  isAssignBtnDisabled;
  errors: string[] = [];
  shopMetadata: IShopMetadata | any;
  private destroyed$: Subject<any> = new Subject();

  constructor(private shopService: ShopService) {}

  ngOnInit(): void {
    this.shopService.shop$.pipe(takeUntil(this.destroyed$)).subscribe((shop) => {
      this.shopMetadata = shop?.metadata;
    });
    this.isAssignBtnDisabled = this.isAssignDisabled();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected) {
      this.errors = [];
      this.isAssignBtnDisabled = this.isAssignDisabled();
    }
  }
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  deslectItems() {
    this.onDeselectItems.emit();
  }

  openDialog() {
    this.onOpenDialog.emit();
  }

  isAssignDisabled() {
    //checks are irrelevant if only 1 order in batch

    if (this.selected.length > 0) {
      const checkMissingPackage = this.shopMetadata?.flagWeightInAssign && this.checkMissingPackage();
      const checkMissingWeight = this.shopMetadata?.flagPackageInAssign && this.checkMissingWeight();
      if (checkMissingPackage || checkMissingWeight) {
        return true;
      }

      if (this.selected.length === 1) return false;

      const differentShipFromLocation = this.checkDifferentShipFromLocations();
      const mixPickupVsShipping = this.checkMixPickupVsShipping();
      const internetionalVsDomestic = this.checkInternationalVsDomestic();

      return differentShipFromLocation || mixPickupVsShipping || internetionalVsDomestic;
    }

    return true;
  }

  checkMissingWeight() {
    const hasMissingWeight = this.selected.some((o) => {
      return o.orderStatus.includes(OrderStatus.FLAG_ASSIGN_WEIGHT);
    });
    const mismatch = hasMissingWeight;
    if (mismatch) {
      this.addError('Unable to batch orders missing items weight');
    }
    return mismatch;
  }

  checkMissingPackage() {
    const hasMissingPackage = this.selected.some((o) => {
      return o.orderStatus.includes(OrderStatus.FLAG_ASSIGN_BOX);
    });
    const mismatch = hasMissingPackage;
    if (mismatch) {
      this.addError('Unable to batch orders with missing package');
    }
    return mismatch;
  }

  checkDifferentShipFromLocations() {
    const shipFromId = this.selected.find((o) => !!o.shipFromAddress?.id)?.shipFromAddress?.id;
    if (!shipFromId) return false;
    const mismatch = shipFromId ? !this.selected.every((o) => o?.shipFromAddress?.id === shipFromId) : true;
    if (mismatch) {
      this.addError('Orders from different inventories can’t be batched.');
    }
    return mismatch;
  }

  checkMixPickupVsShipping() {
    const pickupId = this.selected.find((o) => !!o.pickUpLocationId)?.pickUpLocationId;
    if (!pickupId || this.disablePickupCheckOnPlatforms.includes(this.shopService.shopPlatform)) {
      return false;
    }
    const mismatch = pickupId ? !this.selected.every((o) => o?.pickUpLocationId === pickupId) : true;
    if (mismatch) {
      this.addError('Pickup & Carrier orders cant be batch together.');
    }
    return mismatch;
  }

  checkInternationalVsDomestic() {
    const hasDomestic = this.selected.some((o) => {
      const shipFromCountry = o.shipFromAddress?.countryCode || o.shipFromAddress?.country || this.shopCountry;
      return o.shippingAddress?.countryCode === shipFromCountry || o.shippingAddress?.country === shipFromCountry;
    });
    const hasInternational = this.selected.some((o) => {
      const shipFromCountry = o.shipFromAddress?.countryCode || o.shipFromAddress?.country || this.shopCountry;
      return o.shippingAddress?.countryCode !== shipFromCountry && o.shippingAddress?.country !== shipFromCountry;
    });

    console.log('Batch has Domestic orders: ', hasDomestic);
    console.log('Batch has International orders: ', hasInternational);

    const mismatch = hasDomestic && hasInternational;

    if (mismatch) {
      this.addError('International & Domestic orders cant be batch together.');
    }

    return mismatch;
  }

  addError(err) {
    if (!this.errors.includes(err)) {
      this.errors.push(err);
    }
  }
}
